module.exports = __webpack_public_path__ + "static/media/icon.27948df5.svg";